"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryNeedsReloading = queryNeedsReloading;

function queryNeedsReloading(query) {
  // inclusion of these clauses causes observation to switch to a less efficient reloading method
  var {
    join: join,
    sortBy: sortBy,
    take: take,
    skip: skip
  } = query.description;
  return !!join.length || !!sortBy.length || !!take || !!skip;
}